
/**
 * The type of (redux) action which sets the audio-only flag for the current
 * conference.
 *
 * {
 *     type: SET_AUDIO_ONLY,
 *     audioOnly: boolean
 * }.
 */
export const SET_AUDIO_ONLY = 'SET_AUDIO_ONLY';

/**
 * The type of (redux) action which sets the audio-only flag for the car mode
 * conference.
 *
 * {
 *     type: SET_CARMODE_AUDIO_ONLY,
 *     audioOnlyCarMode: boolean
 * }.
 */
export const SET_CARMODE_AUDIO_ONLY = 'SET_CARMODE_AUDIO_ONLY';
